import React from 'react'

const InputBox = ({ type, name, value, onChange, onBlur, placeholder, disable }) => {
    return (
        <input type={type} name={name} value={value} onChange={onChange} onBlur={onBlur} className="form-control" placeholder={placeholder} disabled={disable} />
    )
}

export default InputBox